import React from "react";
import "./Digitalizacion.css";
import TarjetaDeServicioDigi from "./components/TarjetaDeServicioDigitalizacion";
import GestionDigitalizacion from "./components/GestionDigitalizacion";
import { useTranslation } from "react-i18next";

interface ServiceItem {
  title: string;
  desc: string;
}

export default function Digitalizacion() {
  const { t } = useTranslation();

  const services: ServiceItem[] = [
    {
      title: t("pages.digitalizacion.services.0.title"),
      desc: t("pages.digitalizacion.services.0.desc"),
    },
    {
      title: t("pages.digitalizacion.services.1.title"),
      desc: t("pages.digitalizacion.services.1.desc"),
    },
    {
      title: t("pages.digitalizacion.services.2.title"),
      desc: t("pages.digitalizacion.services.2.desc"),
    },
    {
      title: t("pages.digitalizacion.services.3.title"),
      desc: t("pages.digitalizacion.services.3.desc"),
    },
    {
      title: t("pages.digitalizacion.services.4.title"),
      desc: t("pages.digitalizacion.services.4.desc"),
    },
  ];

  return (
    <>
      <div
        className="digitalizacion-background"
        style={{
          backgroundImage: 'url("/Digitalizacion.webp")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-end",
          paddingRight: "clamp(1rem, 4vw, 4rem)",
        } as React.CSSProperties}
      >
        <div className="digitalizacion-overlay">
          <h1>
            {t("pages.digitalizacion.title")}{" "}
            <span className="subtitulo">
              {t("pages.digitalizacion.subtitle")}
            </span>
          </h1>
          <p>{t("pages.digitalizacion.description")}</p>
        </div>
      </div>
      <h2
        style={{
          textAlign: "center",
          marginTop: "50px",
          fontWeight: "bold",
          lineHeight: "1.6",
          fontSize: "clamp(1.1rem, 3.5vw, 36px)",
        } as React.CSSProperties}
      >
        {t("pages.digitalizacion.why_title")} <br />
        {t("pages.digitalizacion.why_subtitle")}
      </h2>
      <div className="card-grid-digi">
        {services.map((s, i) => {
          let animationClass = "";
          if (i === 0) animationClass = "from-left";
          else if (i === 1) animationClass = "from-bottom";
          else if (i === 2) animationClass = "from-right";
          else if (i === 3) animationClass = "from-left";
          else if (i === 4) animationClass = "from-bottom";
          return (
            <TarjetaDeServicioDigi
              key={s.title}
              service={s}
              animationClass={animationClass}
              delay={0}
            />
          );
        })}
      </div>

      <GestionDigitalizacion
        gestion={[
          {
            titulo: t("pages.digitalizacion.gestion.0.titulo"),
            descripcion: t("pages.digitalizacion.gestion.0.descripcion"),
          },
          {
            titulo: t("pages.digitalizacion.gestion.1.titulo"),
            descripcion: t("pages.digitalizacion.gestion.1.descripcion"),
          },
          {
            titulo: t("pages.digitalizacion.gestion.2.titulo"),
            descripcion: t("pages.digitalizacion.gestion.2.descripcion"),
          },
          {
            titulo: t("pages.digitalizacion.gestion.3.titulo"),
            descripcion: t("pages.digitalizacion.gestion.3.descripcion"),
          },
        ]}
        alcance={[
          { titulo: t("pages.digitalizacion.alcance.0.titulo") },
          { titulo: t("pages.digitalizacion.alcance.1.titulo") },
          { titulo: t("pages.digitalizacion.alcance.2.titulo") },
          { titulo: t("pages.digitalizacion.alcance.3.titulo") },
          { titulo: t("pages.digitalizacion.alcance.4.titulo") },
          { titulo: t("pages.digitalizacion.alcance.5.titulo") },
          { titulo: t("pages.digitalizacion.alcance.6.titulo") },
          { titulo: t("pages.digitalizacion.alcance.7.titulo") },
          { titulo: t("pages.digitalizacion.alcance.8.titulo") },
        ]}
      />
    </>
  );
}
